import React from 'react'
import { Text } from 'rebass'
// const creatHistory = require("history").createHashHistory

// components
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import Tabs from './components/Tabs'

const ExchangeTop:React.FC = ({children}) => {
  return (
    <>
      <BodyHead bottom={'5px'}>
        <BodyTitle fontSize={32} fontWeight={700}>
          Gamification
        </BodyTitle>
        <Text fontSize={14} fontWeight={500}>
          The Power of Creativity, Gamification of DEFI World {' '}
          <span role="img" aria-label="smile">
            😋
          </span>
        </Text>
      </BodyHead>
      <Tabs></Tabs>
      {children}
    </>
  )
}

export default ExchangeTop
